// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-icon {
  width: 280px;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), filter 0.25s ease;
}

a:hover .app-icon {
  transform: scale(1.04) translateY(-6px);
  filter: drop-shadow(0 12px 24px rgba(0, 0, 0, 0.18));
}

.app-icon-small {
  width: 70px;
}

.login-link {
  color: #3399FE;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease, opacity 0.15s ease;
}
.login-link:hover {
  color: #1a77d4;
  text-decoration: underline;
}

.Grow-appear {
  transform: scale(0.8);
  opacity: 0;
}

.Grow-appear.Grow-appear-active {
  opacity: 1;
  transform: scale(1);
  transition: all 0.3s linear;
}

.Grow-enter {
  opacity: 0;
  transform: scale(0.8);
}

.Grow-enter.Grow-enter-active {
  opacity: 1;
  transform: scale(1);
  transition: all 0.2s linear 0.4s;
}

.Grow-exit {
  opacity: 1;
  transform: scale(1);
}

.Grow-exit.Grow-exit-active {
  opacity: 0;
  position: absolute;
  width: 100%;
  transform: scale(1.1);
  transition: all 0.2s linear;
}`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,2EAAA;AACF;;AAEA;EACE,uCAAA;EACA,oDAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,gDAAA;AACF;AACE;EACE,cAAA;EACA,0BAAA;AACJ;;AAIA;EAGE,qBAAA;EACA,UAAA;AADF;;AAIA;EACE,UAAA;EAGA,mBAAA;EACA,2BAAA;AADF;;AAIA;EACE,UAAA;EAGA,qBAAA;AADF;;AAGA;EACE,UAAA;EAGA,mBAAA;EACA,gCAAA;AAAF;;AAEA;EACE,UAAA;EAGA,mBAAA;AACF;;AACA;EACE,UAAA;EACA,kBAAA;EACA,WAAA;EAGA,qBAAA;EACA,2BAAA;AAEF","sourcesContent":[".app-icon {\n  width: 280px;\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), filter 0.25s ease;\n}\n\na:hover .app-icon {\n  transform: scale(1.04) translateY(-6px);\n  filter: drop-shadow(0 12px 24px rgba(0,0,0,0.18));\n}\n\n.app-icon-small {\n  width: 70px;\n}\n\n.login-link {\n  color: #3399FE;\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.15s ease, opacity 0.15s ease;\n\n  &:hover {\n    color: #1a77d4;\n    text-decoration: underline;\n  }\n}\n\n// Page transition animations\n.Grow-appear {\n  -webkit-transform: scale(0.8);\n  -ms-transform: scale(0.8);\n  transform: scale(0.8);\n  opacity: 0;\n}\n\n.Grow-appear.Grow-appear-active {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n  transition: all 0.3s linear;\n}\n\n.Grow-enter {\n  opacity: 0;\n  -webkit-transform: scale(0.8);\n  -ms-transform: scale(0.8);\n  transform: scale(0.8);\n}\n.Grow-enter.Grow-enter-active {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n  transition: all 0.2s linear 0.4s;\n}\n.Grow-exit {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  -ms-transform: scale(1);\n  transform: scale(1);\n}\n.Grow-exit.Grow-exit-active {\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  -webkit-transform: scale(1.1);\n  -ms-transform: scale(1.1);\n  transform: scale(1.1);\n  transition: all 0.2s linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
